export default "__VITE_ASSET__8372ed99__"